var HighlightZone = require('./frApiHighlightZone'),
    RedactionZone = require('./frApiRedactionZone');



module.exports = function( noteType ) {

    if ( noteType === 'REDACTION_NOTE' ) {
        return RedactionZone;
    }

    else if ( noteType === 'HIGHLIGHT_NOTE' ) {
        return HighlightZone;
    }



};


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/models/api/zone/frApiZoneFactory.js
 ** module id = 677
 ** module chunks = 0
 **/